import React from 'react';
import { useParams } from 'react-router-dom';
import { blogData } from '../blogData';
import BlogCta from '../components/BlogCta/BlogCta'; // Import the new CTA component
import './SinglePostPage.css';

const SinglePostPage = () => {
  const { slug } = useParams(); // Get the slug from the URL
  const post = blogData.find((p) => p.slug === slug);

  if (!post) {
    return (
        <div className="container" style={{padding: '80px 0', textAlign: 'center'}}>
            <h2>Post not found!</h2>
        </div>
    );
  }

  return (
    <>
      <article className="single-post-section">
        <div className="container">
          <div className="post-header">
           
            <div className="post-meta">
              <span><strong>Category:</strong> {post.category}</span>
              <span><strong>Published on:</strong> {post.date}</span>
            </div>
          </div>
          <div 
            className="post-content"
            dangerouslySetInnerHTML={{ __html: post.content }} // Renders the HTML content
          />
          {/* Add the new CTA component at the end */}
          <BlogCta category={post.category} />
        </div>
      </article>
    </>
  );
};

export default SinglePostPage;
